import "./styles/app.scss";
import React from 'react';
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from './app';

const renderApp = Component =>
	render(
		<Component />,
		document.getElementById("root")
	);

renderApp(App);
